import React, { useRef } from 'react';
import { useInView } from '../hooks';

interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  y?: number;
}

const Reveal: React.FC<RevealProps> = ({ children, delay = 0, y = 20 }) => {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref);

  return (
    <div
      ref={ref}
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : `translateY(${y}px)`,
        transition: `opacity 0.7s ease ${delay}s, transform 0.7s ease ${delay}s`,
      }}
    >
      {children}
    </div>
  );
};

export default Reveal;
